import React, {FC} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"

import {ErrorCard} from "./styled/LoadingServerError"

interface Props extends InjectIntl {
  errorMsg?: {error: string}
}

const LoadingServerError: FC<Props> = (props) => {
  const {errorMsg, formatMessage} = props

  const errorMessage = errorMsg?.error || formatMessage({id: "platform.loadingServerError.default.error"})

  return <ErrorCard>{errorMessage}</ErrorCard>
}

export default injectIntl(LoadingServerError)
